import { z } from 'zod';
import { isoDateTime, slugSchema } from './common';

/**
 * Partenaire — an organisation MTC partners with (clinics, labs, suppliers…).
 * Surfaced in the home "Partenaires" strip; each links to its own detail page.
 * Fully admin-editable.
 */
export const partenaireInputSchema = z.object({
  slug: slugSchema,
  name: z.string().min(2),
  /** Short tagline under the logo (e.g. "Centre Dentaire · Casablanca"). */
  tagline: z.string().max(200).default(''),
  /** Longer description shown on the detail page. */
  description: z.string().default(''),
  /** Uploaded logo URL — null until provided. */
  logo: z.string().url().nullable().default(null),
  /** Loose strings (not `.url()`) so admins can paste bare domains/handles. */
  website: z.string().max(300).optional(),
  city: z.string().max(80).optional(),
  email: z.string().max(160).optional(),
  phone: z.string().max(40).optional(),
  instagramUrl: z.string().max(300).optional(),
  facebookUrl: z.string().max(300).optional(),
  /** Lower = earlier in the home strip. */
  displayOrder: z.number().int().default(100),
  published: z.boolean().default(true),
});
export type PartenaireInput = z.infer<typeof partenaireInputSchema>;

export const partenaireSchema = partenaireInputSchema.extend({
  id: z.string(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
});
export type Partenaire = z.infer<typeof partenaireSchema>;
